<template>
  <div class="row pt-3">
    <div class="col">
      <ProfileSubSectionHeader
        title="Transportation"
        icon="transportation-icon"
      />
      <ul
        v-if="statuses && statuses.length > 0"
        class="profile-status-list mt-3"
      >
        <GfbOptionDisplay
          v-for="(status, index) in statuses"
          :key="index"
          :status="status.status"
          :text="status.label"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import ProfileSubSectionHeader from "../ProfileSubSectionHeader.vue"
import GfbOptionDisplay from "@/components/GfbOptionDisplay"
import { booleanToOptionStatus } from "@/utils/converters"

export default {
  name: "candidate-profile-status",
  props: {
    profile: {
      type: Object,
      required: true,
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    statuses() {
      const { jobSeeker } = this.profile
      if (jobSeeker) {
        const {
          validDriversLicense,
          validCdlLicense,
          cdlClass,
          reliableTransportation,
        } = jobSeeker ?? {}
        const cdlLabel =
          validCdlLicense && cdlClass
            ? `Valid CDL License (Class ${cdlClass})`
            : "Valid CDL License"
        const statuses = [
          {
            label: "Valid Driver's License",
            status: booleanToOptionStatus(validDriversLicense),
          },
          {
            label: cdlLabel,
            status: booleanToOptionStatus(validCdlLicense),
          },
          {
            label: "Reliable Transportation",
            status: booleanToOptionStatus(reliableTransportation),
          },
        ].filter(Boolean)
        return statuses
      }
      return []
    },
  },
  components: { ProfileSubSectionHeader, GfbOptionDisplay },
}
</script>

<style lang="scss" scoped>
.profile-status-list {
  width: 100%;
  list-style: none;
  padding: 0;

  li {
    margin-bottom: 18px;
    font-weight: 600;
  }
}
</style>
